<template>
    <nav class="container" :class="wrapperClasses" role="navigation" aria-label="Breadcrumbs">
        <ul class="BreadCrumbs">
            <li v-if="showRootUrl">
                <a
                    href="/"
                >
                    Home
                </a>
                <BaseIcon
                    icon="chevron-right"
                />
            </li>
            <li
                v-for="(item, index) in items"
                :key="index"
            >
                <a
                    :href="'/' + item.uri"
                    class="middle-link heavier"
                >
                    {{ index == 0 && (!showRootUrl) ? 'Home' : item.title }}
                </a>
                <BaseIcon
                    icon="chevron-right"
                />

            </li>
            <li>
                {{ current }}
            </li>
        </ul>
    </nav>
</template>
<script>
export default {
    name: 'BreadCrumbs',
    props: {
        items: {
            type: Array,
            default: null
        },
        current: {
            type: String,
            required: true
        },
        showRootUrl: {
            type: Boolean,
            required: false,
            default: true,
        },
        wrapperClasses: {
            type: String,
            required: false,
            default: 'pb-medium mt-large',
        }
    }
}
</script>
<style lang="scss">

    .BreadCrumbs {
        display: flex;
        font-size: 12px;
        font-weight: 600;

        li {
            display: flex;
            align-items: center;
            color: getColour('grey', 'medium');

            a {
                color: getColour('grey', 'dark');

                &.middle-link {
                    font-size: 12px;

                    @include media-query(palm) {
                        font-size: 10px;
                    }
                }
            }
        }
    }

    .BreadCrumbs__list-item {


        &:nth-last-child(2) .BaseIcon {
            opacity: .2;
        }
    }

    .BreadCrumbs__list-item--fade {
        color: getColour('grey', 'medium');
    }

    .BreadCrumbs .BaseIcon {
        margin: 0 0.5rem;
        font-size: 8px;
    }
</style>
